const payment = {
  quickPayment: '/payments/quick-payment',
  quickPaymentList: '/payments/quick-payment-list',
  paymentHistory: '/payments/payment-history',
  coalIronOre: {
    create: '/payments/coal-iron-ore/new',
    paymentPending: '/payments/coal-iron-ore/payment-pending',
    paymentInitiated: '/payments/coal-iron-ore/payment-initiated',
    challanApproval: '/payments/coal-iron-ore/challan-approval',
    podApproval: '/payments/coal-iron-ore/pod-approval',

    canceledChallans: '/payments/coal-iron-ore/canceled-challans',
    update: id => `/payments/coal-iron-ore/update/${id}`
  },
  flyAsh: {
    paymentPending: '/payments/flyAsh/payment-pending',
    paymentInitiated: '/payments/flyAsh/payment-initiated',
    canceledChallans: '/payments/flyAsh/canceled-challans'
  },
  vendorInvoices: {
    createInvoices: '/payments/vendor-invoices/create-invoices',
    invoicesScan: id => `/payments/vendor-invoices/create-invoices/scan/${id}`,
    checkInvoices: '/payments/vendor-invoices/check-invoices',
    paidInvoices: '/payments/vendor-invoices/paid-invoices',
    rejectedInvoices: '/payments/vendor-invoices/rejected-invoices'
  },
  truckerPayments: {
    pendingList: '/payments/trucker-payments/pending-list',
    // truckerPaidsPayments: '/payments/trucker-payments/pending-list/history',
    checkingList: '/payments/trucker-payments/checking-list',
    approvalList: '/payments/trucker-payments/approval-list',
    paymentList: '/payments/trucker-payments/payment-list'
  },
  truckerPayment: {
    truckerPayments: '/payments/trucker-payments/pending',
    truckerPaymentsPending: '/payments/trucker-payments/pending',
    truckerPaidsPayments: '/payments/trucker-payments/pending-list/paids'
  }
  // truckerPayments: '/payments/trucker-payments'
};

export default payment;
